import type { Ref } from 'vue'
import { createSharedComposable, useScrollLock } from '@vueuse/core'
import { computed, onScopeDispose, watch } from 'vue'

const useSharedScrollLock = createSharedComposable(() => {
  const body = computed(() => (typeof document === 'undefined' ? undefined : document.body))
  const locked = useScrollLock(body)
  const owners = new Set<symbol>()

  return (id: symbol, active: boolean) => {
    if (active) {
      owners.add(id)
    } else {
      owners.delete(id)
    }
    locked.value = owners.size > 0
  }
})

export function useOverlayScrollLock(active: Ref<boolean>) {
  const update = useSharedScrollLock()
  const id = Symbol('scroll-lock')
  watch(active, value => update(id, value), { immediate: true, flush: 'sync' })
  onScopeDispose(() => update(id, false))
}
